import { useCallback, useEffect, useState } from 'react';
import { getPageRef } from 'utils/logger';

const ERROR_HINTS: Record<number, string> = {
  7006: 'The scanner could not be loaded. Please check your internet connection and reload the page.',
  7014: 'Not enough free memory on this device. Please close other browser tabs and apps, then reload the page.',
};

const useError = (alert) => {
  const [errorMessage, setErrorMessage] = useState<string>();

  const displayError = useCallback((message: string) => {
    setErrorMessage(message);
  }, []);

  useEffect(() => {
    if (alert?.code === -1) {
      setErrorMessage('');
      return;
    }

    if (alert?.code) {
      // Ref lets support find this device's logs (see utils/logger.ts)
      const ref = `(Ref: ${getPageRef()})`;
      displayError(
        ERROR_HINTS[alert.code]
          ? `Error: ${alert.code}. ${ERROR_HINTS[alert.code]} ${ref}`
          : `Error: ${alert.code} ${ref}`,
      );
    }
  }, [alert]);

  return errorMessage;
};
export default useError;
